import { IGet_wars_war_id_ok } from "../service/esiclient";
import { BaseEntity } from ".";
import { CorporationEntity } from ".";
import { AllianceEntity } from ".";
import { getCachedCorporationEntity } from "./CorporationEntityCache";
import { getCachedAllianceEntity } from "./AllianceEntityCache";
import moment from "moment";

export class WarEntity extends BaseEntity {
  constructor(id: number, props: any) {
    super(id, props);
    this._dataTypeName = "War";
  }

  async toJson(): Promise<Excel.EntityCellValue> {
    const props: Partial<IGet_wars_war_id_ok> = this.props;

    var entity = await super.toJson();

    // Properties
    // - aggressor
    if (entity.properties && props.aggressor) {
      if (props.declared) {
        const declared = moment(props.declared);
        entity.properties["declared"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: declared.unix() / 86400 + 25569,
          numberFormat: "[$-409]m/d/yy h:mm AM/PM;@",
        };
      }
      if (props.aggressor.corporation_id !== undefined) {
        let corporationEntity: CorporationEntity | null = null;
        try {
          corporationEntity = await getCachedCorporationEntity(props.aggressor.corporation_id);
          // eslint-disable-next-line no-empty
        } catch {}
        if (corporationEntity !== null) {
          entity.properties["aggressor"] = await corporationEntity.toJson();
        }
      } else if (props.aggressor.alliance_id !== undefined) {
        let allianceEntity: AllianceEntity | null = null;
        try {
          allianceEntity = await getCachedAllianceEntity(props.aggressor.alliance_id);
          // eslint-disable-next-line no-empty
        } catch {}
        if (allianceEntity !== null) {
          entity.properties["aggressor"] = await allianceEntity.toJson();
        }
      }
      entity.properties["aggressor_isk_destroyed"] = {
        type: Excel.CellValueType.double,
        basicValue: props.aggressor.isk_destroyed,
      };
      entity.properties["aggressor_ships_killed"] = {
        type: Excel.CellValueType.formattedNumber,
        basicValue: props.aggressor.ships_killed,
        numberFormat: "##0",
      };
    }

    // - defender
    if (entity.properties && props.defender) {
      if (props.defender.corporation_id !== undefined) {
        let corporationEntity: CorporationEntity | null = null;
        try {
          corporationEntity = await getCachedCorporationEntity(props.defender.corporation_id);
          // eslint-disable-next-line no-empty
        } catch {}
        if (corporationEntity !== null) {
          entity.properties["defender"] = await corporationEntity.toJson();
        }
      } else if (props.defender.alliance_id !== undefined) {
        let allianceEntity: AllianceEntity | null = null;
        try {
          allianceEntity = await getCachedAllianceEntity(props.defender.alliance_id);
          // eslint-disable-next-line no-empty
        } catch {}
        if (allianceEntity !== null) {
          entity.properties["defender"] = await allianceEntity.toJson();
        }
      }
      entity.properties["defender_isk_destroyed"] = {
        type: Excel.CellValueType.double,
        basicValue: props.defender.isk_destroyed,
      };
      entity.properties["defender_ships_killed"] = {
        type: Excel.CellValueType.formattedNumber,
        basicValue: props.defender.ships_killed,
        numberFormat: "##0",
      };
    }

    // - Text and Name
    if (entity.properties) {
      entity.text = `${(entity.properties["aggressor"] as Excel.EntityCellValue).text} vs ${
        (entity.properties["defender"] as Excel.EntityCellValue).text
      }`;

      entity.properties["name"] = {
        type: Excel.CellValueType.string,
        basicValue: entity.text,
      };
    }

    // Layouts
    entity.layouts = {
      card: {
        title: { property: "name" },
      },
    };

    return entity;
  }
}
